





























































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {Branch, BranchInitState} from '@/store/branch/branch.types';
import BgThemePublic from '@/components/bg-theme-public.vue';
import * as _ from 'underscore';

@Component({
  components: {
    BgThemePublic
  }
})
export default class ContactComponent extends Vue {

  @State('branch') branchInitState!: BranchInitState;
  @Action('_getBranchForMember', {namespace: 'branch'}) getBranchForMember!: () => Promise<Branch[]>;
  @Action('_getByBranchId', {namespace: 'branch'}) getByBranchId!: (payload: string) => Promise<Branch>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public readyBranch = false;
  public branch = {} as Branch;
  public listBranch = [{}] as Branch[];

  async mounted() {
    this.Loading(true);
    this.branch = await this.getByBranchId('8bcf8b25-d839-48aa-8173-bdb90f6851d6');
    this.listBranch = await this.getBranchForMember();
    this.listBranch = await _.sortBy(this.listBranch.filter((item) => item.id !== '8bcf8b25-d839-48aa-8173-bdb90f6851d6'), (item) => {
      return item.branchNo
    });
    this.readyBranch = true;
    this.Loading(false);
  }

}
